// Тактическая ракета "Фудзи" — trigger: «Когда убивает юнита: +2 Влияния».
// Срабатывает только когда прямая атака Фудзи стала причиной смерти юнита.
// Ответный удар (когда Фудзи убил атакующего ответкой) НЕ триггерит.
// Если убил несколько юнитов за один Ф3 — каждое срабатывание отдельно.

import { addInfluence } from './influence.js';

export const CARD_ID = 'deus_takticheskaya_raketa_fudzi';

export function fudziKillUnit(state, ownerIdx) {
  addInfluence(state, ownerIdx, 2, 'Фудзи [убил юнита]');
}
